import {Component, ViewChild, Input, ElementRef, Renderer2} from '@angular/core';

import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import {TranslateService} from "@ngx-translate/core";
import * as moment from 'moment';
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {OnDropdownFilteredEventArgs} from "../../../slick-grid/models/on-dropdown-filtered-event-args";

@Component({
    selector: 'simple-tab',
    templateUrl: './simple-tab.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './simple-tab.component.css']
})
export class SimpleTabComponent extends TabComponentBase<any, { columns: { header: string, field: string }[], mainRows: any[] }> {
    constructor(graphService: BufferGraphService, exchangeService: BufferGraphDataExchangeService,  translateService: TranslateService, renderer: Renderer2, elementRef: ElementRef){

        super(graphService, exchangeService, translateService, renderer, elementRef);


        //this.dataView.onRowsChanged.subscribe(() => this.setCellCssStyles());
        this.options = {syncColumnCellResize: true, multiColumnSort: true, editable: false};
        this.generateColumns = true;
        this.styleGridCells = true;
        this.dataView = new Slick.Data.DataView<any>();
        this.dataView.onRowsChanged.subscribe(() => this.setMainGridSellStyles());


        this.helper.wait( () => this.translateService.get(this.tab.hdr).subscribe(t => this.mainRowsSheetName = t))
        // this.helper.wait( () => this.mainRowsSheetName = this.tab.hdr)
    }


    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    protected isActive: boolean;

    @Input()
    private set data(data: any[]) {
        this.dataView.setItems(data);
    }

    // protected sku: string;

    // protected warehouseCode: string;

    @Input()
    protected canSend: boolean;

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;


    //# set filter on grid
    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }
        this.dataView.setFilter(o => this.gridRef.filterHelper.filter(o));
    }

    //# download excel
    private onDownloadClick = (): void => {
        const fileName = `${this.mainRowsSheetName}_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.graphService.downloadBufferChangeHistory(data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName)
            .map(file => { return { fileContent: file, fileName }; }));
    }

    //# send excel to email
    private onSendClick = (): void => {
        this.sendToEmail(data => this.graphService.sendBufferChangeHistory(this.tab.itemInfo.sku, this.tab.itemInfo.warehouseCode, data.columns, data.mainRows, moment.locale(), this.mainRowsSheetName));
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/simple-tab.component/simple-tab.component.ts